import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import i18next from "i18next";
import Cookies from "js-cookie";

import {
  getRobotsDirective,
  normalizeLanguage,
  resolveLanguage,
  withLanguageQuery
} from "../Configs/LanguageConfig";

const LanguageHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { language } = resolveLanguage({
    search: location.search,
    hostname: window.location.hostname,
    cookieLanguage: Cookies.get("i18next")
  });

  useEffect(() => {
    const nextSearch = withLanguageQuery(location.search, language);

    if (normalizeLanguage(i18next.language) !== language) {
      i18next.changeLanguage(language);
    }

    if (normalizeLanguage(Cookies.get("i18next")) !== language) {
      Cookies.set("i18next", language);
    }

    if (nextSearch !== location.search) {
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch,
          hash: location.hash
        },
        { replace: true }
      );
    }
  }, [language, location, navigate]);

  return (
    <Helmet defer={ false }>
      <meta name="robots" content={getRobotsDirective(language)} />
    </Helmet>
  );
};

export { resolveLanguage, withLanguageQuery };

export default LanguageHandler;
